import { Badge, BadgePosition, BadgeType, FolderOpenIcon, Link, LinkSize, Tooltip } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../translations';

type MedicalInformationModalOpenLinkProps = {
   readonly onClick: VoidFunction;
   readonly unsignedAttachmentCount: number;
   readonly size: LinkSize;
};

export const MedicalInformationModalOpenLink = (props: MedicalInformationModalOpenLinkProps): JSX.Element => {
   return (
      <Tooltip
         testId={'openMedicalInformation'}
         content={patientMedicalInformationTranslationKeys.table.medicalInformation.dataPreview}
      >
         <Link
            testId={'openMedicalInformation'}
            onClick={props.onClick}
            size={props.size}
            icon={
               <Badge
                  type={BadgeType.NEGATIVE}
                  count={props.unsignedAttachmentCount}
                  position={BadgePosition.TOP_RIGHT}
                  testId={'unsignedAttachmentCount'}
                  visible={props.unsignedAttachmentCount > 0}
                  compact
               >
                  <FolderOpenIcon />
               </Badge>
            }
         />
      </Tooltip>
   );
};
